// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"814":"8c48218a","908":"1df806e8"}[chunkId] + ".chunk.js";
};